const breadcrumb = {
  title: 'Terms and Conditions'
}

export default breadcrumb
